"use client";

import { c as _c } from "react/compiler-runtime";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { resolveIpfsUrlSync } from "@/components/ipfs/IPFSContext";
import type { ApiDropPollOption } from "@/generated/models/ApiDropPollOption";
import type { ApiIdentityOverview } from "@/generated/models/ApiIdentityOverview";
import { DROP_POLL_OPTION_VOTER_PREVIEW_PAGE_SIZE, useDropPollOptionVoters } from "@/hooks/useDropPollOptionVoters";
import Image from "next/image";
import Link from "next/link";
import { getIdentityHrefValue, getIdentityLabel, shouldLimitIdentityLabel } from "./WaveDropPoll.helpers";
function PollVoterAvatar(t0) {
  const $ = _c(8);
  const {
    identity
  } = t0;
  let t1;
  if ($[0] !== identity) {
    t1 = getIdentityLabel(identity);
    $[0] = identity;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const label = t1;
  if (!identity.pfp) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="tw-size-4 tw-flex-shrink-0 tw-rounded-full tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-800 tw-object-cover" aria-hidden="true" />;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] !== identity.pfp) {
    t2 = resolveIpfsUrlSync(identity.pfp);
    $[3] = identity.pfp;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `${label}'s avatar`;
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <Image unoptimized={true} src={t2} alt={t3} width={16} height={16} className="tw-size-4 tw-flex-shrink-0 tw-rounded-full tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-800 tw-object-cover" />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function PollVoterRow(t0) {
  const $ = _c(20);
  const {
    voter
  } = t0;
  let hrefValue;
  let label;
  let t1;
  if ($[0] !== voter) {
    label = getIdentityLabel(voter);
    hrefValue = getIdentityHrefValue(voter);
    t1 = shouldLimitIdentityLabel(label);
    $[0] = voter;
    $[1] = hrefValue;
    $[2] = label;
    $[3] = t1;
  } else {
    hrefValue = $[1];
    label = $[2];
    t1 = $[3];
  }
  const shouldLimit = t1;
  let t2;
  if ($[4] !== voter) {
    t2 = <PollVoterAvatar identity={voter} />;
    $[4] = voter;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = `/${encodeURIComponent(hrefValue)}`;
  const t4 = `tw-block tw-min-w-0 ${shouldLimit ? "tw-max-w-[10rem] tw-truncate" : "tw-truncate"}`;
  let t5;
  if ($[6] !== label) {
    t5 = <span className="tw-text-[11.5px] tw-text-iron-400 tw-transition-all tw-duration-300 desktop-hover:group-hover:tw-text-iron-200">{label}</span>;
    $[6] = label;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <span className={t4}>{t5}</span>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t6) {
    t7 = <Link href={t3} onClick={_temp} className="tw-group tw-min-w-0 tw-no-underline tw-transition-all tw-duration-300 desktop-hover:hover:tw-opacity-80">{t6}</Link>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== hrefValue || $[15] !== t7) {
    t8 = <UserProfileTooltipWrapper user={hrefValue}>{t7}</UserProfileTooltipWrapper>;
    $[14] = hrefValue;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t2 || $[18] !== t8) {
    t9 = <div className="-tw-mx-1.5 tw-flex tw-min-w-0 tw-items-center tw-gap-1.5 tw-rounded tw-px-1.5 tw-py-0.5 tw-transition-colors desktop-hover:hover:tw-bg-iron-800">{t2}{t8}</div>;
    $[17] = t2;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}
function _temp(event) {
  return event.stopPropagation();
}
function PollOptionVoterPreviewAvatar(t0) {
  const $ = _c(8);
  const {
    identity
  } = t0;
  let t1;
  if ($[0] !== identity) {
    t1 = getIdentityLabel(identity);
    $[0] = identity;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const label = t1;
  if (!identity.pfp) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <span className="tw-size-5 tw-flex-shrink-0 tw-rounded-full tw-border tw-border-solid tw-border-iron-900 tw-bg-iron-800 tw-object-cover" aria-hidden="true" />;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] !== identity.pfp) {
    t2 = resolveIpfsUrlSync(identity.pfp);
    $[3] = identity.pfp;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `${label}'s avatar`;
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <Image unoptimized={true} src={t2} alt={t3} width={20} height={20} className="tw-size-5 tw-flex-shrink-0 tw-rounded-full tw-border tw-border-solid tw-border-iron-900 tw-bg-iron-800 tw-object-cover" />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
export function PollOptionVoterPreviews(t0) {
  const $ = _c(13);
  const {
    dropId,
    option
  } = t0;
  const t1 = option.votes > 0;
  let t2;
  if ($[0] !== dropId || $[1] !== option.option_no || $[2] !== t1) {
    t2 = {
      dropId,
      optionNo: option.option_no,
      enabled: t1,
      pageSize: DROP_POLL_OPTION_VOTER_PREVIEW_PAGE_SIZE
    };
    $[0] = dropId;
    $[1] = option.option_no;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    voters
  } = useDropPollOptionVoters(t2);
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[4] !== voters) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const previewVoters = voters.slice(0, DROP_POLL_OPTION_VOTER_PREVIEW_PAGE_SIZE);
      if (previewVoters.length === 0) {
        t6 = null;
        break bb0;
      }
      t3 = "tw-flex tw--space-x-1.5 tw-opacity-80 tw-transition-opacity desktop-hover:group-hover/result:tw-opacity-100";
      t4 = "true";
      t5 = previewVoters.map(_temp2);
    }
    $[4] = voters;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t7 = <span className={t3} aria-hidden={t4}>{t5}</span>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}
function _temp2(voter) {
  return <PollOptionVoterPreviewAvatar key={voter.id} identity={voter} />;
}
export function PollOptionVoters(t0) {
  const $ = _c(18);
  const {
    dropId,
    option,
    enabled
  } = t0;
  const t1 = enabled && option.votes > 0;
  let t2;
  if ($[0] !== dropId || $[1] !== option.option_no || $[2] !== t1) {
    t2 = {
      dropId,
      optionNo: option.option_no,
      enabled: t1
    };
    $[0] = dropId;
    $[1] = option.option_no;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    voters,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isFetchingNextPage,
    isError
  } = useDropPollOptionVoters(t2);
  if (option.votes === 0) {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="tw-text-xs tw-font-medium tw-text-iron-500">No votes yet</div>;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  if (isLoading) {
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="tw-text-xs tw-font-medium tw-text-iron-500">Loading voters...</div>;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  if (isError) {
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="tw-text-xs tw-font-medium tw-text-rose-300">Voters could not be loaded.</div>;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  let t3;
  if ($[7] !== voters) {
    t3 = voters.map(_temp3);
    $[7] = voters;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <div className="tw-flex tw-flex-col tw-gap-2">{t3}</div>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== fetchNextPage || $[12] !== hasNextPage || $[13] !== isFetchingNextPage) {
    t5 = hasNextPage && <div className="tw-mt-2"><button type="button" disabled={isFetchingNextPage} onClick={event => {
        event.stopPropagation();
        fetchNextPage().catch(_temp4);
      }} className="tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-solid tw-border-iron-700 tw-bg-transparent tw-px-2.5 tw-py-1.5 tw-text-xs tw-font-semibold tw-text-iron-400 tw-transition disabled:tw-cursor-not-allowed disabled:tw-opacity-60 desktop-hover:hover:tw-border-iron-600 desktop-hover:hover:tw-text-iron-200">{isFetchingNextPage ? "Loading..." : "Load more"}</button></div>;
    $[11] = fetchNextPage;
    $[12] = hasNextPage;
    $[13] = isFetchingNextPage;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <div>{t4}{t5}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}
function _temp4() {}
function _temp3(voter) {
  return <PollVoterRow key={voter.id} voter={voter} />;
}